<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid"  @keyup.enter.native="getChangepkgGroupListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="getChangepkgGroupListHandler" >查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"  >
            <el-table-column type="index" label="序号" align="center"></el-table-column>      
            <el-table-column label="ICCID号" width="160" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" align="center"></el-table-column>
            <el-table-column prop="oldPkgGroupName" label="原套餐组名称" align="center"></el-table-column>
            <el-table-column prop="newPkgGroupName" label="新套餐组名称" align="center"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="操作人" align="center"></el-table-column>>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>       
    </div>
</template>
<script>
import {getChangepkgGroupList} from '@/api/record.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        getChangepkgGroupListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getChangepkgGroupList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })      
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getChangepkgGroupListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getChangepkgGroupListHandler();
        }  
    },
    created () {
        this.getChangepkgGroupListHandler()
    }
}
</script>
<style lang="less" scoped>

</style>

